import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";

type IconAvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

type IconAvatarProps = {
    icon: IconDefinition;
    size?: IconAvatarSize;
    className?: string;
};

const sizeClasses: Record<IconAvatarSize, { container: string; icon: string }> = {
    xs: { container: 'h-8 w-8', icon: 'text-xs' },
    sm: { container: 'h-10 w-10', icon: 'text-sm' },
    md: { container: 'h-12 w-12', icon: 'text-lg' },
    lg: { container: 'h-16 w-16 sm:h-24 sm:w-24', icon: 'text-2xl sm:text-4xl' },
    xl: { container: 'h-24 w-24 sm:h-32 sm:w-32', icon: 'text-4xl sm:text-5xl' },
};

const IconAvatar: React.FC<IconAvatarProps> = ({ icon, size = 'md', className = '' }) => {
    const { container, icon: iconSize } = sizeClasses[size];

    return (
        <span className={`inline-flex items-center justify-center rounded-full bg-red-600 ${container} ${className}`}>
            <FontAwesomeIcon icon={icon} className={`${iconSize} text-white`} />
        </span>
    );
};

export default IconAvatar;
